export const tracking = {
    app: 'ECS',
    step: {
        init: 'INIT',
        search: {
            startSearchButton: 'BTN_SEARCH_START',
            startSearchHelpDialog: {
                buttonSearchLastInput: 'BTN_SEARCH_LASTINPUT',
            },
            multipleSearch: {
                open: 'BTN_OPEN_MULTIPLESEARCH',
                startSearchButton: 'BTN_START_MULTIPLESEARCH',
            },
            successful: 'STEP_SEARCH_SUCCESSFUL',
            notSuccessful: 'STEP_SEARCH_NOTSUCCESSFUL',
            ocrNameplate: 'BTN_SEARCH_OCR',
        },
        product: {
            backToStartButton: 'BTN_PRODUCT_BACK_TO_SEARCH',
            addToCart: 'BTN_PRODUCT_ADD_TO_CART',
            showProductData: 'BTN_PRODUCT_DATA',
            showDocumentation: 'BTN_DOCUMENTATION',
            requestRepairService: 'BTN_REPAIR_SERVICE',
            checkRecommendedParts: 'BTN_OVERLAY_APPLY',
        },
        parts: {
            addToCartActionbar: 'BTN_PARTS_ADD_TO_CART',
            addToCartSingle: 'BTN_PART_ADD_TO_CART',
            addToCartGroup: 'BTN_HG_ADD_TO_CART',
            exportListAsCsv: 'BTN_CLICK_EXPORT',
            redirectToDriveConfi: 'BTN_PARTS_REDIRECT_TO_DRIVECONFI',
        },
        overlayRight: {
            close: 'BTN_CLOSE_OVERLAY',
        },
        furtherLinks: {
            searchArchive: 'BTN_ARCHIVE_ETL',
            download: 'BTN_DOWNLOAD_ETL',
            thirdPartyDrive: 'BTN_FORM_3RDPARTY',
        },
        wizard: {
            close: 'BTN_CLOSE_WIZARD',
            addToCard: 'BTN_WIZARD_ADD_TO_CART',
            next: 'BTN_WIZARD_NEXT',
            step: {
                gearOil: 'STEP_WIZARD_GEAROIL',
                cable: 'STEP_WIZARD_CABLE',
                eCover: 'STEP_WIZARD_ECOVER',
            },
        },
        accessoriesAndServices: {
            service: {
                tab: 'BTN_OPEN_SERVICESHEET',
                serviceInhouse: 'BTN_CLICK_SERVICEINHOUSE',
                serviceInhouseNext: 'BTN_NEXT_SERVICEINHOUSE',
                serviceOnsite: 'BTN_CLICK_SERVICEONSITE',
                serviceOnsiteNext: 'BTN_NEXT_SERVICEONSITE',
                serviceContact: 'BTN_CLICK_SERVICECONTACT',
                serviceBack: 'BTN_CLICK_SERVICEBACK',
            },
            gearOil: {
                tab: 'BTN_OPEN_OILSHEET',
                search: 'BTN_SEARCH_OILSERIAL',
            },
        },
    },
};
